export function isRow(grid) {
    return (grid.item === false || typeof grid.item === "undefined");
}
